import _extends from "@babel/runtime-corejs2/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
var _excluded = ["isField", "error"];
import * as React from 'react';
var TextArea = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var isField = props.isField,
    error = props.error,
    extraProps = _objectWithoutProperties(props, _excluded); // eslint-disable-line no-unused-vars
  // $FlowFixMe[cannot-spread-inexact]
  return /*#__PURE__*/React.createElement("textarea", _extends({
    className: "form-control"
  }, extraProps, {
    ref: ref
  }));
});
TextArea.displayName = 'TextArea';
export default TextArea;